// const source = 'podsDataTable'

function aggiungiVociFatturaMassivo () {

    this.$eventBus.emit('show-dialog-page', {
      page: 'pods-aggiungi-voci-fattura-massivo',
      title: 'Aggiungi Voci Fattura Massivo',
      data: {type:'ee'},
      maximize: false,

    })
  
}

export default {
  'bindTo': 'this',
  'method': aggiungiVociFatturaMassivo,
}
